module.exports = __webpack_public_path__ + "static/media/berkshire_winter_small.cf9290af.jpg";